import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../../../api/queries/getModuleSpecs';
import { ModuleType } from '../../../../../api/types';
import LoadingElement from '../../../../../components/LoadingElement';
import NotFoundResult from '../../../../../components/results/NotFoundResult';
import UpdateAudiCalculationSettingInnerPage from './UpdateAudiCalculationSettingInnerPage';

const UpdateAudiCalculationSettingPage = () => {
    const { moduleId, settingId } = useParams<{ moduleId: string; settingId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    if (module.__typename !== ModuleType.AudiCalculationModule) {
        return <NotFoundResult />;
    }

    const audiCalculationSetting = module.audiCalculationSettings.find(item => item.id === settingId);

    if (!audiCalculationSetting) {
        return <NotFoundResult />;
    }

    return <UpdateAudiCalculationSettingInnerPage module={module} setting={audiCalculationSetting} />;
};

export default UpdateAudiCalculationSettingPage;
